import { render, staticRenderFns } from "./changeRealMessage.vue?vue&type=template&id=773ac8e8&scoped=true&"
import script from "./changeRealMessage.vue?vue&type=script&lang=js&"
export * from "./changeRealMessage.vue?vue&type=script&lang=js&"
import style0 from "./changeRealMessage.vue?vue&type=style&index=0&id=773ac8e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ac8e8",
  null
  
)

export default component.exports